module.exports = require("graphql-codegen-core");